import { Dispatch } from 'redux';
import { getEmployerChangeLogs } from '../../global/ducks/change-log-api';
import { getFormattedDateYmd } from '../../global/helpers/date-helpers';
import { KeyValuePair } from '../../pages/arc/models/arc-epi-props';
import { submitted } from '../components/date-type-filter';
import { DateType, EmployeeChangeLogApiFilter, EmployeeChangeLogApiResponse, EmployeeChangeLogItem, EmployeeChangeLogPayload } from '../models/employee-changelog-item-models';
import { BackendSearchState, FilterOptions, FilterTypes, SearchApp, SortBy } from '../models/search-models';
import { defaultBackendPageSize, setBeginRequest, setEndRequest, setFilterOptions, setList, setPaginationInfo } from '../slices/backend-search-slice';

export const defaultPayload: EmployeeChangeLogPayload = {
	page: '1',
	limit: '15',
	filter_by: {
	},
	sort_by: {
		field: FilterTypes.submittedDate,
		order_by: SortBy.DESCENDING,
	},
};

export function mapEventType(value: string, mapList: KeyValuePair[]): string {

	if (mapList?.length > 0) {
		return mapList.find(v => value?.toLocaleLowerCase() === v?.key.toLocaleLowerCase())?.value || value;
	}

	return value;
}

function mapEventTypeItem(value: EmployeeChangeLogItem, mapList: KeyValuePair[]): EmployeeChangeLogItem {
	return {
		...value,
		event_type: mapEventType(value.event_type, mapList),
	};
}

export function parseFilterOptions(response: EmployeeChangeLogApiResponse, mapList: KeyValuePair[]): { [key: string]: FilterOptions } {

	const filterOptions: any = {};

	if (response?.distinct_filter?.entities) {
		filterOptions[FilterTypes.employee] = {
			type: FilterTypes.employee,
			options: response?.distinct_filter?.entities?.map(e => {
				return {
					key: FilterTypes.employee,
					display: `${e?.first_name} ${e?.last_name}`,
					value: e?.guid,
				};
			}),
		};
	}

	if (response?.distinct_filter?.event_type) {
		filterOptions[FilterTypes.eventType] = {
			type: FilterTypes.eventType,
			options: response?.distinct_filter?.event_type?.map(e => {
				return {
					key: FilterTypes.eventType,
					display: mapEventType(e.desc, mapList),
					value: e.desc,
				};
			}),
		};
	}

	if (response?.distinct_filter?.submitted_by) {
		filterOptions[FilterTypes.submittedBy] = {
			type: FilterTypes.submittedBy,
			options: response?.distinct_filter?.submitted_by?.map(e => {
				return {
					key: FilterTypes.submittedBy,
					display: e,
					value: e,
				};
			}),
		};
	}

	return filterOptions;
}

export function handleEmployeeChangeLogResponse(response: EmployeeChangeLogApiResponse, mapList: KeyValuePair[], dispatch: Dispatch<any>) {

	const mappedEventLogs = response.eventLogs.map(i => mapEventTypeItem(i, mapList));

	dispatch(setFilterOptions(parseFilterOptions(response, mapList), SearchApp.CHANGE_LOG));
	dispatch(setList(mappedEventLogs, SearchApp.CHANGE_LOG));
	dispatch(setPaginationInfo(response?.pagination?.totalPages, response?.pagination?.totalRecordsCount, response?.pagination?.pageSize, SearchApp.CHANGE_LOG));
}

export function createFilterPayload(searchState: BackendSearchState) {
	const filterBy: EmployeeChangeLogApiFilter = {};

	const filter: EmployeeChangeLogPayload = {
		page: searchState?.currentPage?.toString(),
		limit: searchState?.pageSize?.toString() || `${defaultBackendPageSize}`,
		filter_by: filterBy,
	};

	const eventType = searchState?.seletedFilters.filter(f => f.type === FilterTypes.eventType);
	const entities = searchState?.seletedFilters.filter(f => f.type === FilterTypes.employee);
	const submittedBy = searchState?.seletedFilters.filter(f => f.type === FilterTypes.submittedBy);
	const from = searchState?.seletedFilters.filter(f => f.type === FilterTypes.from);
	const to = searchState?.seletedFilters.filter(f => f.type === FilterTypes.to);
	const dateType = searchState?.seletedFilters.filter(f => f.type === FilterTypes.dateType)[0];

	const sort = searchState?.sorts[0];

	filterBy.date_type = (dateType?.value === submitted || !dateType?.value) ? DateType.SUBMITTED : DateType.EFFECTIVE;

	if (from[0]?.value || to[0]?.value) {

		filterBy.date_type = from[0]?.value?.split(':')[0] === submitted ? DateType.SUBMITTED : DateType.EFFECTIVE;		

		const range: any = {};

		if (from[0]?.value) {
			range.from_date = getFormattedDateYmd(from[0]?.value?.split(':')[1], true);
		}

		if (to[0]?.value) {
			range.to_date = getFormattedDateYmd(to[0]?.value?.split(':')[1], true);
		}

		filterBy.date_range = range;
	}
	if (eventType?.length > 0) {
		filterBy.event_type = eventType?.map(e => e.value);
	}

	if (entities?.length > 0) {
		filterBy.entities = entities?.map(e => e.value);
	}

	if (submittedBy?.length > 0) {
		filterBy.submitted_by = submittedBy?.map(e => e.value);
	}
	if (sort) {
		filter.sort_by = {
			field: sort.type,
			order_by: sort.sortBy,
		};
	}
	return filter;
}

export function updateChangeLogList(searchState: BackendSearchState, mapList: KeyValuePair[], dispatch: Dispatch<any>, clientNumber: string, app: SearchApp) {
	if (clientNumber) {
		dispatch(setBeginRequest(app));
		dispatch(getEmployerChangeLogs(
			clientNumber,
			createFilterPayload(searchState),
			(response) => handleEmployeeChangeLogResponse(response?.data, mapList, dispatch),
			() => setEndRequest(app),
		));
	}
}
